import React, { useEffect, useState } from "react";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Foundry", href: "#foundry" },
    { label: "Ecosystem", href: "#ecosystem" },
    { label: "Founders", href: "#founders" },
    { label: "Press", href: "#press" },
  ];

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[rgba(247,247,246,0.82)] backdrop-blur-xl border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-baseline gap-2"
        >
          <span className="font-serif-display text-[26px] tracking-tight">MERA</span>
          <span className="font-mono-label text-[10px] text-black/50 hidden sm:inline">
            Technology
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-label text-[11px] text-black/70 hover:text-black transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#waitlist"
          data-testid="nav-cta"
          className="mera-btn mera-btn-ghost"
        >
          <span className="dot" />
          Get Started
        </a>
      </div>
    </header>
  );
};
